import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from 'ngx-alerts';
import {DashboardService} from '../../../services/dashboard.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {LOCAL_STORAGE, SESSION_STORAGE, StorageService} from 'ngx-webstorage-service';
import {finalize} from 'rxjs/operators';
import {PageEvent} from '@angular/material/paginator';

@Component({
  selector: 'app-alert-customers',
  templateUrl: './alert-customers.component.html',
  styleUrls: ['./alert-customers.component.scss']
})
export class AlertCustomersComponent implements OnInit {

  alertCustomers: any[] = [];
  search = {
    channelId: '',
    isDrivingAlerts: false,
    isVehicleAlerts: false,
    page: 0,
    size: 20,
    userType: ''
  };
  totalRecords = 0;
  loggedInUser: any;
  pageEvent: PageEvent;

  constructor(private router: Router, private route: ActivatedRoute, private alertService: AlertService,
              public dashboardService: DashboardService, private spinner: NgxSpinnerService,
              @Inject(LOCAL_STORAGE) private storage: StorageService,) {
    this.loggedInUser = storage.get('gs-loggedInUser');
    this.search.channelId = this.loggedInUser.channelId;
    this.search.userType = this.storage.get('gs-loggedInUserType');
  }


  ngOnInit(): void {
    let queryParams = this.route.snapshot.queryParams;
    this.search.isDrivingAlerts = queryParams.isDrivingAlerts;
    this.search.isVehicleAlerts = queryParams.isTroubleCodes;
    this.getAlertCustomers();
  }

  private getAlertCustomers() {
    this.spinner.show();
    this.dashboardService.getAlertCustomers(this.search).pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.totalRecords = res.totalRecords;
        this.alertCustomers = res.remindersData;
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }

  getServerData(ev: PageEvent) {
    this.search.page = ev.pageIndex;
    this.search.size = ev.pageSize;
    this.getAlertCustomers();
    return ev;
  }

}
